import { useCallback, useSyncExternalStore } from 'react'

/** Phones get the one-column relation page below this width (ED-50). */
export const DESKTOP_QUERY = '(min-width: 768px)'

/**
 * Whether a media query matches, following changes. Where `matchMedia` does not exist
 * (jsdom in tests) it answers `fallback`: the desktop layout.
 */
export function useMediaQuery(query: string, fallback = true): boolean {
  // Stable between renders, so React subscribes once per query instead of on every render.
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof window.matchMedia !== 'function') return () => {}
      const list = window.matchMedia(query)
      list.addEventListener('change', onChange)
      return () => list.removeEventListener('change', onChange)
    },
    [query],
  )
  const getSnapshot = useCallback(
    () => (typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : fallback),
    [query, fallback],
  )
  return useSyncExternalStore(subscribe, getSnapshot, () => fallback)
}
